import * as React from 'react'
import {Component} from "../Utils"
import {sumBy, indexOf} from 'lodash'
import {isGroupCheck} from "../controls/standart/validate";
import {IGroupSchema} from "../controls/standart/Group";
import {IPanelSchema} from "../controls/standart/Panel";
import {findIndex, isUndefined, isEmpty} from 'lodash'

interface ActionsProps {
  schema: any;
  progress: number;
  isVisible: boolean;
  status: number;
  isPdf: boolean;
  onSend: () => void;
  onPDF: () => void;
  onDraft: () => void;
  onDocument: () => void;
  onRevoke: () => void;
  onDelete: () => void;
  onCopy: () => void;
  onAddition: () => void;
}

function getCountRequired(sections: Array<any>, checkPanel: Array<string>) {
  let count = 0;
  for (let section of sections) {
    count += getCountRequiredInSection(section.controls, checkPanel);
  }

  return count;
}

function getCountRequiredInSection(controls: Array<any>, checkPanel: Array<string>) {
  for (let ctrl of controls) {
    if (ctrl.type.toUpperCase() !== 'PANEL' && ctrl.required) {
      return 1;
    } else if (indexOf(checkPanel, ctrl.id) > -1) {
      return getCountRequiredInSection(ctrl.controls, checkPanel);
    }
  }

  return 0;
}

export default class Actions extends Component<ActionsProps, null> {

  getCheckedPanels(): Array<string> {
    const {form, values} = this.props.schema;
    const arr = [];
    for (let section of form.sections) {
      for (let control of section.controls) {
        if (control.hasOwnProperty('controls')) {
          const valueIdx = findIndex(values, (val: any) => val.controlid === control.id);
          if (isGroupCheck(control as IGroupSchema | IPanelSchema, values[valueIdx])) {
            arr.push(control.id)
          }
        }
      }
    }
    return arr;
  }

  render() {
    const {status, isVisible} = this.props;

    return (
      <div className="reportbox-actions">
        <div className="note">Данные заявки сохраняются автоматически</div>
        <div className="btn-content">
          <button className="btn btn-success btn-sm pull-right" onClick={this.props.onRevoke}>
            Назад к списку заявок
          </button>
          {isVisible && (
            <button className="btn btn-success btn-sm pull-right" onClick={this.props.onDocument}>
              Отправить
            </button>
          )}
        </div>
      </div>
    )
  }
}
